import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>Такой страницы не существует</h1>
    </div>
  );
};

export default NotFound;
